import React, { useState } from 'react';
import { Text, Button } from '@nextui-org/react';
import { AdminSessionDetail } from '../../../types/sessions';

interface Props {
    detail: AdminSessionDetail;
}

const CanvasTab: React.FC<Props> = ({ detail }) => {
    const [viewMode, setViewMode] = useState<'timeline' | 'final'>('timeline');

    const snapshots = detail.canvas_snapshots || [];
    const finalSnapshot = snapshots.length > 0 ? snapshots[snapshots.length - 1] : null;

    const renderSnapshot = (snapshot: any, isFinal: boolean = false) => {
        return (
            <div style={{
                border: '1px solid #eaeaea',
                padding: '1rem',
                borderRadius: '8px',
                minWidth: isFinal ? '100%' : '300px',
                background: '#fff',
                flexShrink: 0
            }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
                    <Text b>Turn {snapshot.turn_number}</Text>
                    <Text size={12} color="#888">{new Date(snapshot.captured_at).toLocaleTimeString()}</Text>
                </div>

                {Object.entries(snapshot.canvas_state).map(([field, data]: [string, any]) => (
                    <div key={field} style={{ marginBottom: '0.5rem' }}>
                        <Text b size={13} css={{ textTransform: 'capitalize' }}>{field}</Text>
                        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                            <Text size={11} color="#666" css={{ background: '#f4f4f5', padding: '2px 4px', borderRadius: '4px' }}>
                                {data.status}
                            </Text>
                            <Text size={14}>{data.content || '-'}</Text>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div style={{ padding: '1rem' }}>
             <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
                 <Button size="sm" bordered={viewMode !== 'timeline'} onClick={() => setViewMode('timeline')}>Timeline</Button>
                 <Button size="sm" bordered={viewMode !== 'final'} onClick={() => setViewMode('final')}>Final</Button>
             </div>

             {viewMode === 'timeline' ? (
                 <div style={{ display: 'flex', gap: '1rem', overflowX: 'auto', paddingBottom: '1rem' }}>
                     {snapshots.map((snap, i) => (
                         <React.Fragment key={i}>
                            {renderSnapshot(snap)}
                         </React.Fragment>
                     ))}
                     {snapshots.length === 0 && <Text>No canvas snapshots found.</Text>}
                 </div>
             ) : (
                 <div>
                     {finalSnapshot ? renderSnapshot(finalSnapshot, true) : <Text>No final snapshot.</Text>}
                 </div>
             )}

             <Button size="sm" css={{ marginTop: '1rem' }} disabled>
                 Show diff between snapshots
             </Button>
        </div>
    );
};

export default CanvasTab;